export default "__VITE_ASSET__ewckxl0Y__"